import { useContext } from 'react';
import { ModalsContext } from 'context/ModalsContext';

const useModalContext = () => {
  const ctx = useContext(ModalsContext);
  return { ...ctx };
};

export default useModalContext;
